import { getApiBaseUrl } from '../utils/apiBaseUrl';

function apiUrl(path) {
  const base = getApiBaseUrl();
  return base ? `${base}${path}` : path;
}

function getToken() {
  try {
    return window.localStorage.getItem('jassp-auth-token') || '';
  } catch {
    return '';
  }
}

function headers() {
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${getToken()}`,
  };
}

async function readJson(res) {
  return res.json().catch(() => ({}));
}

async function throwIfError(res) {
  const data = await readJson(res);
  if (!res.ok || !data.ok) {
    throw new Error(typeof data.error === 'string' ? data.error : `HTTP ${res.status}`);
  }
  return data;
}

/* Dashboard */
export async function fetchAdminDashboard(signal) {
  const res = await fetch(apiUrl('/api/admin/dashboard'), {
    method: 'GET',
    signal,
    headers: { Accept: 'application/json', Authorization: `Bearer ${getToken()}` },
  });
  return throwIfError(res);
}

/* Users */
export async function fetchUsers() {
  const res = await fetch(apiUrl('/api/admin/users'), { headers: headers() });
  return throwIfError(res);
}

export async function createUser(payload) {
  const res = await fetch(apiUrl('/api/admin/users'), {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(payload),
  });
  return throwIfError(res);
}

export async function updateUser(id, payload) {
  const res = await fetch(apiUrl(`/api/admin/users/${encodeURIComponent(id)}`), {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify(payload),
  });
  return throwIfError(res);
}

export async function deleteUser(id) {
  const res = await fetch(apiUrl(`/api/admin/users/${encodeURIComponent(id)}`), {
    method: 'DELETE',
    headers: headers(),
  });
  return throwIfError(res);
}

/* Domains */
export async function fetchDomains() {
  const res = await fetch(apiUrl('/api/admin/domains'), { headers: headers() });
  return throwIfError(res);
}

export async function createDomain(payload) {
  const res = await fetch(apiUrl('/api/admin/domains'), {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(payload),
  });
  return throwIfError(res);
}

export async function updateDomain(id, payload) {
  const res = await fetch(apiUrl(`/api/admin/domains/${encodeURIComponent(id)}`), {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify(payload),
  });
  return throwIfError(res);
}

export async function deleteDomain(id) {
  const res = await fetch(apiUrl(`/api/admin/domains/${encodeURIComponent(id)}`), {
    method: 'DELETE',
    headers: headers(),
  });
  return throwIfError(res);
}

/* Projects */
export async function fetchProjects() {
  const res = await fetch(apiUrl('/api/admin/projects'), { headers: headers() });
  return throwIfError(res);
}

export async function createProject(payload) {
  const res = await fetch(apiUrl('/api/admin/projects'), {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(payload),
  });
  return throwIfError(res);
}

export async function updateProject(id, payload) {
  const res = await fetch(apiUrl(`/api/admin/projects/${encodeURIComponent(id)}`), {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify(payload),
  });
  return throwIfError(res);
}

export async function deleteProject(id) {
  const res = await fetch(apiUrl(`/api/admin/projects/${encodeURIComponent(id)}`), {
    method: 'DELETE',
    headers: headers(),
  });
  return throwIfError(res);
}
